function snakeToCamelCase(str) {
  return str.replace(/_\w/g, (m) => m[1].toUpperCase());
}

export default snakeToCamelCase;
